import { AdCampaignStatusesEnum, AdCampaignTypeEnum, ReplicationRole } from '@shared/api/graphql/generated';
import { Colors } from '@zvuk-b2b/react-uikit/ui/types';

import { TEXTS } from '../texts';

export const AD_STATUSES_LABELS = {
  all: TEXTS.TAB_ALL_TITLE,
  [AdCampaignStatusesEnum.Active]: TEXTS.TAB_ACTIVE_TITLE,
  [AdCampaignStatusesEnum.Passed]: TEXTS.TAB_PASSED_TITLE,
  [AdCampaignStatusesEnum.Planned]: TEXTS.TAB_PLANNED_TITLE,
  [AdCampaignStatusesEnum.Stopped]: TEXTS.TAB_STOPPED_TITLE,
};

export const AD_STATUSES_COLORS = {
  all: undefined,
  [AdCampaignStatusesEnum.Active]: Colors.COLOR_SUCCESS_500,
  [AdCampaignStatusesEnum.Passed]: Colors.COLOR_NEUTRAL_500,
  [AdCampaignStatusesEnum.Planned]: Colors.COLOR_WARNING_500,
  [AdCampaignStatusesEnum.Stopped]: Colors.COLOR_DANGER_500,
};

export const ALL_ALIAS = 'all';

export const DEFAULT_STATUSES_INFO = {
  [AdCampaignStatusesEnum.Active]: 0,
  [AdCampaignStatusesEnum.Planned]: 0,
  [AdCampaignStatusesEnum.Passed]: 0,
  [AdCampaignStatusesEnum.Stopped]: 0,
};

export const DEFAULT_AD_CAMPAIGN_STATUSES = [
  AdCampaignStatusesEnum.Active,
  AdCampaignStatusesEnum.Passed,
  AdCampaignStatusesEnum.Planned,
  AdCampaignStatusesEnum.Stopped,
];

export const DEFAULT_AD_CAMPAIGN_TYPES = [
  AdCampaignTypeEnum.Interval,
  AdCampaignTypeEnum.Period,
  AdCampaignTypeEnum.ExactTime,
  AdCampaignTypeEnum.Instant,
  AdCampaignTypeEnum.Groups,
];

export const DEFAULT_REPLICATION_ROLES = [ReplicationRole.None, ReplicationRole.Slave];
